/* global attachEvent debounce */

// *******************************************************************************
// Mobile menu toggle
// *******************************************************************************

attachEvent('.hamburger', 'click', (ev) => {
  // Open menu
  document.body.classList.toggle('is-open-menu');
  const hamburger = ev.target.closest('.hamburger');
  const isOpen = hamburger.classList.contains('is-open');
  hamburger.classList.toggle('is-open', !isOpen);
  hamburger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
  ev.preventDefault();
});

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************

function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 5);
}

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    if (isScrolledTop > lastScrollTop) {
      document.body.classList.remove('is-scrolled-up');
    } else {
      document.body.classList.add('is-scrolled-up');
    }
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
  },
  false
);

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

// *******************************************************************************
// Open language menu
// *******************************************************************************

attachEvent('.header-main__language-open', 'click', (ev) => {
  ev.target.closest('.header-main__language').classList.toggle('is-active');
});

// *******************************************************************************

const getHeaderTopBarHeight = () => {
  let headerTopBarHeight = 0;
  const infoBar = document.querySelector('.info-bar');
  if (infoBar) {
    headerTopBarHeight = infoBar.offsetHeight;
    document.body.classList.add('has-top-bar');
  }
  document.body.style.setProperty('--top-bar-height', `${headerTopBarHeight}px`);
};
getHeaderTopBarHeight();

const debounceGetHeaderTopBarHeight = debounce(() => {
  getHeaderTopBarHeight();
}, 100);

window.addEventListener('DOMContentLoaded', () => {
  debounceGetHeaderTopBarHeight();

  window.addEventListener('resize', () => {
    debounceGetHeaderTopBarHeight();
  });
});
